import { useMutation, useQueryClient } from '@tanstack/react-query';
import { galleryService } from '../../../services/GalleryService';
import { galleryQueryKeys } from '../galleryQueryKeys';

export function useAddGalleryImageMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (imageId: string) => galleryService.addImage(imageId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: galleryQueryKeys.imagesRoot(),
      });
    },
  });
}

export function useDeleteGalleryImageMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (imageId: string) => galleryService.deleteImage(imageId),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: galleryQueryKeys.imagesRoot(),
      });
    },
  });
}
